import { Component, ElementRef, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Survey } from 'src/app/models/survey';
import { catchError } from 'rxjs/operators';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { SurveyV2Service } from 'src/app/services/surveyV2.service';
import { ProgressBarComponent } from '../_components/progress-bar/progress-bar.component';
import { SurveyQuestionComponent } from './survey-question/survey-question.component';

@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss'],
    providers: [DataServiceService],
    imports: [ProgressBarComponent,SurveyQuestionComponent,RouterModule],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyComponent implements OnInit {

  title = "Risk Capacity Survey"

  questionIndex: number;

  hidden = false;

  //For survey
  survey
  surveyId

  constructor(
    private route: ActivatedRoute, 
   // private dataservice: DataServiceService, 
   private surveyV2Service: SurveyV2Service, 
    private seoservice: SeoService, 
    public router: Router, 
    private meta: Meta, 
    private elementRef:ElementRef, 
    private sanitizer:DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr:ChangeDetectorRef
  ) { }

  clearPreviousResults(id) {
// $&("clearPreviousResults",id)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(id)
    }
  }

  answered(q) {
// $&("answered:",q)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.survey.resultId + "_" + this.questionIndex, q)
    }

    this.surveyV2Service.survey_question_answered$(
      {
        //"surveyResultId":this.survey.surveyResultId,
        //"surveyResultResponseId": this.survey.questions[this.questionIndex].surveyResultResponseId,
        //"questionIndex":this.questionIndex,
        "guidSurveyResultResponseID":this.survey.questions[this.questionIndex].guidSurveyResultResponseID,
        "selectedAnswer": q
      }
    ) .subscribe(res => {

      if (this.survey.questions.length > this.questionIndex + 1) {
        this.router.navigate([`/survey/${this.survey.surveyId}/${this.questionIndex + 2}`], {skipLocationChange: false})
        
      } else {
        this.surveyV2Service.survey_finish$(this.survey.guidSurveyResultID!).subscribe (resp => {
          this.router.navigate([`/survey/${this.surveyId}/profile`])
        }, error => {
          (error.message || "finish error")
// $&(error)
        })
      }

      this.cdr.detectChanges();

    }, error => {
      (error.message || "question error")
// $&(error)
    } )
    

  }
  

  ngOnInit() {

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // this.dataservice.getSurvey();

    this.route.params.subscribe(params => {
// $&("params", params, this.route.paramMap)
      if (params.surveyId && (params.surveyId == "47" || params.surveyId == "50")) {

        this.surveyId = params.surveyId

        setTimeout(() => { // wait for DOM rendering    
          this.reinsertScripts();
        });

// $&(localStorage.getItem(params.surveyId))
// $&(this.survey)

        if (localStorage.getItem(params.surveyId)==null) {

          this.surveyV2Service.survey_new$(params.surveyId).subscribe(resp => {
            this.survey = resp
// $&(this.survey)
            localStorage.setItem(params.surveyId + "_survey", JSON.stringify(resp))
            localStorage.setItem(params.surveyId, this.survey.resultId)
            localStorage.setItem("surveyID",params.surveyId);       
            
            this.cdr.detectChanges();
        
      })

        } else {
          this.survey = JSON.parse(localStorage.getItem(params.surveyId + "_survey"))
        }

          if (params.questionNumber) {
            this.questionIndex = params.questionNumber - 1
          } else {
            this.questionIndex = 0 //Starting question index
          }
          this.cdr.detectChanges();
    
      }
      
})

this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'catholic investing survey, risk capacity survey, catholic risk capacity survey, investing risk survey, risk survey retirement'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Risk Capacity Survey. Whats Your Financial Risk Capacity?'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'no index, no follow'});

}

reinsertScripts(): void {
  if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  //console.log('reinsertScripts')
  const scripts = < HTMLScriptElement[] > this.elementRef.nativeElement.getElementsByTagName('script');
  const scriptsInitialLength = scripts.length;
  //console.log("scriptsInitialLength",scriptsInitialLength)
  for (let i = 0; i < scriptsInitialLength; i++) {
    const script = scripts[i];
    const scriptCopy = < HTMLScriptElement > document.createElement('script');
    scriptCopy.type = script.type ? script.type : 'text/javascript';
    if (script.innerHTML) {
      scriptCopy.innerHTML = script.innerHTML;
    } else if (script.src) {
      scriptCopy.src = script.src;
    }
    scriptCopy.async = false;

    if (script.src) {
      const alreadyLoaded = Array.from(document.querySelectorAll('script[src]'))
        .some(s => (s as HTMLScriptElement).src === script.src && s !== script);
      if (alreadyLoaded) {
        continue;
      }
    }
    else if(script.innerHTML) {
      const alreadyLoaded = Array.from(document.querySelectorAll('script:not([src])'))
        .some(s => (s as HTMLScriptElement).innerHTML === script.innerHTML && s !== script);
        if (alreadyLoaded) {
          continue;
        }
    }

    script.parentNode.replaceChild(scriptCopy, script);
  }
}

}
